import palette from "../palette";

export default {
  underline: {
    "&:before": {
      borderBottomColor: palette.text.primary
    },
    "&:after": {
      borderBottomColor: palette.white
    }
  },
};
